import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import EmptyTestimonialsImage from "../../assets/images/empty-testimonials-figure.png";

import { testimonialStyles } from "./styles";

const EmptyTestimonials = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });

  return (
    <Box sx={testimonialStyles.container}>
      <Typography sx={testimonialStyles.title}>{t("testimonials")}</Typography>
      <Box sx={testimonialStyles.emptyState.wrapper}>
        <img src={EmptyTestimonialsImage} alt="empty-testimonials" style={testimonialStyles.emptyState.image} />
        <Typography sx={testimonialStyles.emptyState.text}>{t("noTestimonials")}</Typography>
      </Box>
    </Box>
  );
};

export default EmptyTestimonials;
